import script from "./BlockArea.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockArea.vue?vue&type=script&setup=true&lang=js"

import "./BlockArea.vue?vue&type=style&index=0&id=34696f7c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\33\\Desktop\\2024\\block-explorer-ts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34696f7c"]])

export default __exports__